import {
  ProductSettlementStatus,
  ProductSettlementSummary,
  ProductSettlementRegisterResponse,
} from '../../types/settlement/SettlementTypes';
import { ApiResponse } from '../../types/common/ApiResponse';
import { settlementsApi } from '../../api';

const ProductSettlementService = {
  /**
   * Registra un asentamiento individual de producto
   * POST /api/settlements
   */
  register: async (
    payload
  ): Promise<ApiResponse<ProductSettlementRegisterResponse>> => {
    const response = await settlementsApi.add(payload);
    return response.data;
  },

  /**
   * Registra asentamiento general de todos los productos de una compra
   * POST /api/settlements/general?purchaseId=1&branchId=1
   */
  registerGeneral: async (
    purchaseId: number,
    branchId: number
  ): Promise<ApiResponse<ProductSettlementStatus[]>> => {
    const response = await settlementsApi.addCustom(
      `/general?purchaseId=${purchaseId}&branchId=${branchId}`,
      {}
    );
    return response.data;
  },

  /**
   * Consulta los asentamientos de un producto
   * GET /api/settlements/by-product?purchaseId=1&productId=1
   */
  getByProduct: async (
    purchaseId: number,
    productId: number
  ): Promise<ApiResponse<ProductSettlementSummary>> => {
    const response = await settlementsApi.fetchCustom(
      `/by-product?purchaseId=${purchaseId}&productId=${productId}`
    );
    return response.data;
  },

  /**
   * Elimina un asentamiento
   * DELETE /api/settlements?purchaseId=1&productId=2&branchId=3
   */
  delete: async (
    purchaseId: number,
    productId: number,
    branchId: number
  ) => {
    const response = await settlementsApi.removeCustom(
      `?purchaseId=${purchaseId}&productId=${productId}&branchId=${branchId}`
    );
    return response.data;
  },

  /**
 * Consulta una compra con el detalle de asentamiento por producto
 * GET /api/settlements/purchase-progress?purchaseId=ID
 */
  getPurchaseWithProgress: async (
    purchaseId: number
  ) => {
    const response = await settlementsApi.fetchCustom(
      `/purchase-progress?purchaseId=${purchaseId}`
    );
    return response.data;
  },

};

export default ProductSettlementService;
